var _path, _path2, _g, _rect, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "white",
    fillOpacity: 0.38
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5364_8252",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5364_8252)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "var(--color-primary)",
    fillOpacity: 0.08
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5364_8252",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 18,
    width: 60,
    height: 61
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18.75,
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5364_8252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 62.5C53.125 62.5 55.7812 61.4062 57.9688 59.2188C60.1562 57.0312 61.25 54.375 61.25 51.25C61.25 48.125 60.1562 45.4688 57.9688 43.2812C55.7812 41.0938 53.125 40 50 40C46.875 40 44.2188 41.0938 42.0312 43.2812C39.8438 45.4688 38.75 48.125 38.75 51.25C38.75 54.375 39.8438 57.0312 42.0312 59.2188C44.2188 61.4062 46.875 62.5 50 62.5ZM30 71.25C28.625 71.25 27.4479 70.7604 26.4688 69.7812C25.4896 68.8021 25 67.625 25 66.25V36.25C25 34.875 25.4896 33.6979 26.4688 32.7188C27.4479 31.7396 28.625 31.25 30 31.25H37.875L42.5 26.25H57.5L62.125 31.25H70C71.375 31.25 72.5521 31.7396 73.5312 32.7188C74.5104 33.6979 75 34.875 75 36.25V66.25C75 67.625 74.5104 68.8021 73.5312 69.7812C72.5521 70.7604 71.375 71.25 70 71.25H30Z",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCamera);
export default __webpack_public_path__ + "static/media/EmptyCamera.2144594a.svg";
export { ForwardRef as ReactComponent };